/**
 * 指定された幅と高さから、幅に対する高さの比率を計算し、
 * 比率が2.4倍以上または1/2.4以下の場合は1.0を返します。
 * それ以外は通常の比率(width / height)を返します。
 */

const MAX_VALUE = 2.4;

export const calculateOptimalListChildRatio = (
  width: number,
  height: number,
): number => {
  if (width === 0 || height === 0) return 1.0;
  const ratio = width / height;

  if (ratio >= MAX_VALUE || ratio <= 1 / MAX_VALUE) {
    return 1.0;
  }

  return ratio;
};
